import { 
    GET_ACCESSORY_PURCHASE,
    GET_ALL_ACCESSORY_PURCHASES,
    GET_ACCESSORY_PURCHASE_REQUEST,
    CREATE_ACCESSORY_PURCHASE,
    UPDATE_ACCESSORY_PURCHASE,
    DELETE_ACCESSORY_PURCHASE,
    CLEAR_ACCESSORY_PURCHASE
} from '../actions/types';

const initialState = {
    accessoryPurchases: [],
    accessoryPurchase: null,
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
        pages: 0
    },
    loading: true
}

export default (state = initialState, { type, payload }) => {
    switch (type) {

    case CREATE_ACCESSORY_PURCHASE:
        return { 
            ...state, 
            accessoryPurchases: [payload.accessoryPurchase, ...state.accessoryPurchases],
            accessoryPurchase: payload.accessoryPurchase,
            loading: false 
        };

    case GET_ALL_ACCESSORY_PURCHASES:
        return { 
            ...state, 
            accessoryPurchases: payload.accessoryPurchases,
            pagination: {
                page: payload.page,
                limit: payload.limit,
                total: payload.total,
                pages: payload.pages
            },
            loading: false 
        };

    case GET_ACCESSORY_PURCHASE:
        return { 
            ...state, 
            accessoryPurchase: payload.accessoryPurchase,
            loading: false 
        };

    case GET_ACCESSORY_PURCHASE_REQUEST:
        return { 
            ...state, 
            loading: payload 
        };

    case UPDATE_ACCESSORY_PURCHASE:
        return {
            ...state,
            accessoryPurchases: state.accessoryPurchases.map(accessoryPurchase => 
                accessoryPurchase._id === payload.accessoryPurchase._id ? payload.accessoryPurchase : accessoryPurchase
            ),
            accessoryPurchase: payload.accessoryPurchase,
            loading: false
        };

    case DELETE_ACCESSORY_PURCHASE:
        return {
            ...state,
            accessoryPurchases: state.accessoryPurchases.filter(accessoryPurchase => accessoryPurchase._id !== payload),
            loading: false
        };

    case CLEAR_ACCESSORY_PURCHASE:
        return {
            ...state,
            accessoryPurchase: null,
            loading: false
        };

    default:
        return state
    }
}
